import React, { useState } from 'react'
import { isInAppBrowser } from 'utils/inAppBrowserUtils'
import LoginModal from 'components/TeamPublicPage/LoginModal'

// The brand named in the dialog's welcome line. These pages belong to a
// teacher, not to a team, so the platform is the host.
const PLATFORM_NAME = 'TutorNetworking'

/**
 * Starts a student login from a page that is not a team page.
 *
 * In a regular browser that posts the Google OAuth form. Google refuses OAuth
 * inside an in-app browser, so there the reader gets the email login in place
 * instead of a dead end that only offers to copy the URL.
 *
 * `translations` must carry `loginModal` and `inAppBrowser`. Render
 * `loginModal` once anywhere in the component's output.
 */
export default function useStudentLogin(translations) {
  const [isLoginOpen, setIsLoginOpen] = useState(false)

  const startStudentLogin = () => {
    if (isInAppBrowser()) {
      setIsLoginOpen(true)
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    if (!csrfToken) {
      console.error('CSRF token not found')
      return
    }

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/users/auth/google_oauth2?role=student'

    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    document.body.appendChild(form)
    form.submit()
  }

  const loginModal = (
    <LoginModal
      isOpen={isLoginOpen}
      onClose={() => setIsLoginOpen(false)}
      teamName={PLATFORM_NAME}
      translations={translations}
    />
  )

  return { startStudentLogin, loginModal }
}
